import { render, staticRenderFns } from "./MergeHorse.vue?vue&type=template&id=fa377fbe&"
import script from "./MergeHorse.vue?vue&type=script&lang=js&"
export * from "./MergeHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports